import { getJoinValueFromArray, padRightWithSpaces } from '../../../services/lib/utils/helpers'
import { allUrls, urlKey } from '../../../services/api/api-urls'
import { ApiRequest } from '../../../services/api/api'
import { Select } from 'antd'
import React, { useState } from 'react'
import ItipsForProduct from '../i-tips/product'

const { Option } = Select

export const getSelectOptions = async (urlInfoKey: string, selectionGetUrl?: string) => {
  const result = await ApiRequest({
    url: selectionGetUrl || allUrls[urlInfoKey].get,
    method: 'get',
    isShowSpinner: [urlKey.City, urlKey.QuotationOptionItem].includes(urlInfoKey)
  })
  return result.data.data
}

  export const commonFormSelect = (urlInfoKey: string, data: any, valueJoinArray?: any[], disabled?: boolean, onChangeFn?: any, valueKeyString?: any, placeholder?: any, value?: any, showDefault?: boolean, showTips?:boolean) => {
  const id: string = urlInfoKey + 'Id'
  const name: string = urlInfoKey + 'Name'

  const renderOptionContent = (
    urlInfoKey: string,
    showTips: boolean,
    row: any,
    valueJoinArray: any[] | undefined,
    name: string
  ) => {
    // console.log(urlKey.BaseProduct)
    // console.log(urlInfoKey)
    // console.log(showTips)
 
    if (urlKey.Product === urlInfoKey && showTips) {
      return (
        <ItipsForProduct
          id={row.productId}
          isNotCutting={true}
          label={valueJoinArray && valueJoinArray.length ? getJoinValueFromArray(row, valueJoinArray) : row[name]}
        />
      );
    } 
    else if (urlKey.BaseProduct === urlInfoKey && showTips) {

      return (
        <ItipsForProduct
          baseProductId={row.baseProductId}
          isNotCutting={true}
          label={valueJoinArray && valueJoinArray.length ? getJoinValueFromArray(row, valueJoinArray) : row[name]} id={0}        />
      );
    } else {
      return valueJoinArray && valueJoinArray.length ? getJoinValueFromArray(row, valueJoinArray) : row[name];
    }
  };
  return (
    <Select
        placeholder={placeholder || ''}
      allowClear
      showSearch
      style={{width: '100%'}}
      defaultValue={showDefault && data[0][id]}
      disabled={disabled}
      onChange={onChangeFn}
      filterOption={ (input: any, option: any) => {
        const sanitizedInput = input?.trim().replace(/\u2011|\u002d/g, ' ').toLowerCase();
        if (!sanitizedInput) return true;
        const wordsToMatch = sanitizedInput.split(' ').map((word:string)  => word.trim());

        // 处理不同的 children 结构
        let optionText = '';

        // 检查是否是 span 包裹的情况（失效产品）
        if (option?.children?.props?.children) {
          const spanChildren = option.children.props.children;
          // 如果是数组，提取文本内容
          if (Array.isArray(spanChildren)) {
            optionText = spanChildren
              .map((child: any) => {
                if (typeof child === 'string') return child;
                if (child?.props?.label) return child.props.label;
                return '';
              })
              .join(' ')
              .toLowerCase();
          } else if (typeof spanChildren === 'string') {
            optionText = spanChildren.toLowerCase();
          } else if (spanChildren?.props?.label) {
            optionText = spanChildren.props.label.toLowerCase();
          }
        }

        // 原有逻辑：处理 ItipsForProduct 或普通字符串
        if (!optionText) {
          optionText = option?.children?.props?.label?.toLowerCase();
          if (!optionText && typeof option?.children === 'string') {
            optionText = option?.children?.toLowerCase();
          }
        }

        return wordsToMatch.every((word:string) => optionText.indexOf(word) >= 0);
      } }
      value={value}
      onInputKeyDown={ (e: any) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          return
        }
      } }
    >
      {data.map((row: any, index: number) => (
        <Option
          value={valueKeyString ? row[valueKeyString] : row[id]}
          key={index.toString()}
          disabled={row.isInactive} // 禁用失效产品的选择
        >
          <span style={{ color: row.isInactive ? '#999' : 'inherit' }}>
            {renderOptionContent(urlInfoKey, showTips || false, row, valueJoinArray, name)}
            {row.isInactive && ' (Inactive)'}
          </span>
        </Option>
      ))}
    </Select>
  )
}
